<template>
  <svg
    :height="graphHeight + data.length * 32 + 40"
    :width="graphWidth"
    class="chart"
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >

    <g>

      <text
        v-for="(label, index) in xLabels"
        :key="label"
        :fill="colorText"
        :x="100 / xMax * index + '%'"
        :y="graphHeight - 15"
      >
        {{ label }}
      </text>

      <text
        :fill="colorText"
        :y="graphHeight + 20"
        class="chart__axis-label"
        x="50%"
      >
        {{ xUnit }}
      </text>

    </g>

    <g>

      <text
        v-for="(label, index) in yLabels.slice().reverse()"
        :key="label"
        :fill="colorText"
        :y="graphHeight / yMax * index + 15"
        x="-35"
      >
        {{ label }}
      </text>

      <text
        :fill="colorText"
        :x="(graphHeight - 30) / -2 + 15"
        class="chart__axis-label"
        transform="rotate(-90)"
        y="-60"
      >
        {{ yUnit }}
      </text>

    </g>

    <g
      v-for="(graph, gIndex) in data"
      :key="graph.label"
      class="chart__graph"
    >

      <g
        v-for="(point, pIndex) in graph.points"
        :key="`${pIndex}-${point}`"
        transform="translate(30)"
      >
        <circle
          :cx="100 / xMax * pIndex + '%'"
          :cy="graphHeight - graphHeight / yMax * parseInt(point) + 10"
          :fill="graph.color ? graph.color : colorText"
          class="chart__dot"
          r="4"
        />
        <line
          v-if="pIndex < xMax - 1"
          :stroke="graph.color ? graph.color : colorText"
          :x1="100 / xMax * pIndex + '%'"
          :y1="graphHeight - graphHeight / yMax * parseInt(point) + 10"
          :x2="100 / xMax * (pIndex + 1) + '%'"
          :y2="graphHeight - graphHeight / yMax * graph.points[pIndex + 1] + 10"
          class="chart__line"
          stroke-width="2"
        />
        <line
          v-if="pIndex < xMax - 1"
          :x1="100 / xMax * pIndex + '%'"
          :y1="graphHeight - graphHeight / yMax * parseInt(point) + 10"
          :x2="100 / xMax * (pIndex + 1) + '%'"
          :y2="graphHeight - graphHeight / yMax * graph.points[pIndex + 1] + 10"
          stroke="transparent"
          stroke-width="14"
        />
      </g>

      <g :transform="`translate(0 ${graphHeight + gIndex * 32 + 60})`">
        <line
          :stroke="graph.color ? graph.color : colorText"
          class="chart__legend-line"
          stroke-width="2"
          x2="30"
        />
        <text
          :fill="colorText"
          class="chart__legend-text"
          cursor="default"
          dominant-baseline="middle"
          x="40"
        >
          {{ graph.label }}
        </text>
      </g>

    </g>

  </svg>
</template>

<script>
import cssVariables from '@/css/variables'

export default {
  name: 'CChart',

  props: {
    // [
    //   {
    //     points: [1, 2, 3],
    //     color: '#639' // optional
    //   },
    //   {
    //     points: [3, 2, 1],
    //     color: 'red' // optional
    //   }
    // ]
    data: {
      type: Array,
      required: true
    },
    xLabels: {
      type: Array,
      required: true
    },
    xUnit: {
      type: String,
      required: true
    },
    yLabels: {
      type: Array,
      required: true
    },
    yUnit: {
      type: String,
      required: true
    },
    scroll: {
      type: Boolean,
      default: false
    },
    scrollUnitWidth: {
      type: Number,
      default: 120
    }
  },

  computed: {
    graphHeight () {
      return this.yMax * 70
    },
    graphWidth () {
      return (this.scroll === true) ? this.xLabels.length * this.scrollUnitWidth : '100%'
    },
    xMax () {
      return this.xLabels.length
    },
    yMax () {
      return this.yLabels.length
    },
    colorText () {
      return cssVariables['color-text']
    }
  }
}
</script>

<style scoped>
.chart {
  padding-left: 75px;
}

.chart__axis-label {
  font-weight: 700;
  text-anchor: middle;
}

.chart__graph:hover .chart__dot {
  r: 6;
}

.chart__graph:hover .chart__line,
.chart__graph:hover .chart__legend-line {
  stroke-width: 4;
}

.chart__graph:hover .chart__legend-text {
  font-weight: 700;
}
</style>
